import React from 'react';
import styled from '@emotion/styled';
import { useLang } from '../../context/LanguageContext';
import { t } from '../../translations';

const Section = styled.section`
  background: #FFFFFF;
  padding: 100px 50px;

  @media (max-width: 640px) {
    padding: 64px 20px;
  }
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

const SectionHeader = styled.div`
  margin-bottom: 72px;
  text-align: center;

  @media (max-width: 640px) {
    text-align: left;
  }
`;

const Label = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #D97757;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin: 0 0 16px;
`;

const Title = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: clamp(28px, 4vw, 44px);
  font-weight: 700;
  color: #0A0A0A;
  letter-spacing: -1px;
  margin: 0 0 16px;
  max-width: 520px;
  margin: 0 auto 16px;
`;

const Subtitle = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: #666;
  line-height: 1.7;
  max-width: 460px;
  margin: 0 auto;
`;

const Steps = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
  max-width: 640px;
  margin: 0 auto;
`;

const StepRow = styled.div`
  display: grid;
  grid-template-columns: 64px 1fr;
  gap: 0 32px;
  align-items: stretch;
`;

const StepLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StepNumber = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: ${props => props.active ? '#D97757' : '#F0F0F0'};
  border: 1px solid ${props => props.active ? '#D97757' : '#E0E0E0'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Poppins', monospace;
  font-size: 14px;
  font-weight: 700;
  color: ${props => props.active ? '#FFFFFF' : '#AAAAAA'};
  flex-shrink: 0;
  z-index: 1;
  transition: background 200ms ease, border-color 200ms ease;
`;

const StepLine = styled.div`
  width: 1px;
  flex: 1;
  background: #E8E8E8;
  margin: 6px 0;
  min-height: 32px;
`;

const StepContent = styled.div`
  padding: 0 0 40px 0;
`;

const StepTitle = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-size: 17px;
  font-weight: 600;
  color: #111;
  margin: 8px 0 8px;
`;

const StepDesc = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #666;
  line-height: 1.65;
  margin: 0;
  max-width: 540px;
`;

const StepTag = styled.span`
  display: inline-block;
  padding: 2px 10px;
  background: rgba(217,119,87,0.08);
  border: 1px solid rgba(217,119,87,0.15);
  border-radius: 100px;
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #D97757;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 4px;
`;

const numbers = ['01', '02', '03', '04', '05'];

const ProccessShort = () => {
  const { lang } = useLang();
  const tr = t[lang].process;

  return (
    <Section>
      <Container>
        <SectionHeader>
          <Label>{tr.label}</Label>
          <Title>{tr.title}</Title>
          <Subtitle>{tr.subtitle}</Subtitle>
        </SectionHeader>

        <Steps>
          {tr.steps.map((step, i) => (
            <StepRow key={numbers[i]}>
              <StepLeft>
                <StepNumber active={i === 0}>{numbers[i]}</StepNumber>
                {i < tr.steps.length - 1 && <StepLine />}
              </StepLeft>
              <StepContent>
                <StepTag>{step.tag}</StepTag>
                <StepTitle>{step.title}</StepTitle>
                <StepDesc>{step.desc}</StepDesc>
              </StepContent>
            </StepRow>
          ))}
        </Steps>
      </Container>
    </Section>
  );
};

export default ProccessShort;
